import { useMemo } from "react";

interface UseCursorPaginationProps {
  hasNext: boolean;
  hasPrevious: boolean;
  pageSize: number;
  // Caller-supplied: it must reset to the first cursor and refetch with the
  // new limit, since a cursor is only valid for the page size it was issued
  // for. Required, not optional — Pagination.PageSize must always work when
  // composed, regardless of pagination mode.
  onPageSizeChange: (pageSize: number) => void;
}

interface UseCursorPaginationReturn {
  pagination: { pageIndex: number; pageSize: number };
  onPageSizeChange: (pageSize: number) => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
}

function useCursorPagination({
  hasNext,
  hasPrevious,
  pageSize,
  onPageSizeChange,
}: UseCursorPaginationProps): UseCursorPaginationReturn {
  return useMemo(
    () => ({
      pagination: { pageIndex: 0, pageSize },
      onPageSizeChange,
      canPreviousPage: hasPrevious,
      canNextPage: hasNext,
    }),
    [hasPrevious, hasNext, pageSize, onPageSizeChange]
  );
}

export { useCursorPagination };
export type { UseCursorPaginationProps, UseCursorPaginationReturn };
